<h2 mat-dialog-title> Modificar camión</h2>
<mat-dialog-content>

  <form [formGroup]="form">
    <mat-form-field class='formField'>
      <mat-label>Marca</mat-label>
      <input matInput placeholder="Marca" formControlName="marca" [(value)]="marca">
    </mat-form-field>
    <mat-form-field class='formField'>
      <mat-label>Modelo</mat-label>
      <input matInput placeholder="Modelo" formControlName="modelo" [(value)]="modelo">
    </mat-form-field>
    <mat-form-field class='formField'>
      <mat-label>Matricula</mat-label>
      <input matInput placeholder="Matricula" formControlName="matricula" [(value)]="matricula" required>
    </mat-form-field>
    <mat-slide-toggle class='sliderCheck' [checked]="activo" color='primary' formControlName="activo">Activo</mat-slide-toggle>
  </form>


</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cancelar</button>
  <button mat-button (click)="save()">Guardar</button>
</mat-dialog-actions>
